import { render, staticRenderFns } from "./DataIterator.vue?vue&type=template&id=1997a735"
import script from "./DataIterator.vue?vue&type=script&lang=js"
export * from "./DataIterator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports